import { Alert, Button } from '@superdispatch/ui-lab';
import { Stack } from '@superdispatch/ui';
import { Typography } from '@material-ui/core';
import { useEffect } from 'react';
import { useCustomerSupport } from 'shared/helpers/CustomerSupport';
import { LinkAnchor } from 'shared/routing/Links';
import {
  trackInstantTransferRecoveryDismissed,
  trackInstantTransferRecoveryBannerViewed,
  trackInstantTransferRecoveryContactSupportClicked,
  trackInstantTransferRecoveryOrderLinkClicked,
} from './InstantTransferRecoveryAnalytics';

interface InstantTransferNotificationFailedProps {
  notificationContext: {
    status: 'failed';
    load_id: string;
    load_guid: string;
  };
  message: string;
  onClose?: () => void;
}

export function InstantTransferNotificationFailed({
  notificationContext,
  message,
  onClose,
}: InstantTransferNotificationFailedProps) {
  const { showLauncherMessanger } = useCustomerSupport();
  const loadId = notificationContext.load_id;
  const loadGuid = notificationContext.load_guid;

  useEffect(() => {
    trackInstantTransferRecoveryBannerViewed({
      banner_state: 'settlement_failed',
      order_id: loadId,
      orders_count: null,
    });
  }, [loadId]);

  return (
    <Alert
      severity="critical"
      onClose={() => {
        trackInstantTransferRecoveryDismissed({
          banner_state: 'settlement_failed',
          order_id: loadId,
          orders_count: null,
        });
        onClose?.();
      }}
    >
      <Stack space="xxsmall">
        <Typography variant="body1">{message}</Typography>
        <Typography>
          Instant Transfer was issued for{' '}
          <LinkAnchor
            to={`/loads/${loadGuid}`}
            onClick={() => {
              trackInstantTransferRecoveryOrderLinkClicked({
                banner_state: 'settlement_failed',
                order_id: loadId,
              });
            }}
          >
            {loadId}
          </LinkAnchor>
          . Your payment has failed. Contact support to pay the balance and
          regain access to Instant Transfer.
        </Typography>

        <Button
          size="small"
          variant="neutral"
          onClick={() => {
            trackInstantTransferRecoveryContactSupportClicked({
              order_id: loadId,
            });
            showLauncherMessanger();
            onClose?.();
          }}
        >
          Contact Support
        </Button>
      </Stack>
    </Alert>
  );
}
